import { NavDropdown } from "react-bootstrap";

export function XtNavDropdownItem(props) {
    return(<NavDropdown.Item {...props}>{props.children}</NavDropdown.Item>)
}